export default __webpack_public_path__ + "static/bmc_small-7a6e7829e62a962997a7a2531ca4695d.png";